<template>
  <div style="padding: 10px">
    <template v-for="(ft, idx) in formTemplates" :key="idx">
      <el-card :bord-style="{ padding: '0' }" shadow="hover" class="ft-card">
        <el-popover placement="right" trigger="hover">
          <template #reference>
            <img :src="loadImageFromTemplate(ft.imgUrl)" style="width: 200px" />
          </template>
          <img :src="loadImageFromTemplate(ft.imgUrl)" style="width: 300px" />
        </el-popover>
        <div class="bottom clear-fix">
          <span class="ft-title">#{{ idx + 1 }} {{ ft.title }}</span>
          <el-button type="text" class="right-button" @click="loadFormTemplate(ft.jsonUrl)"> {{ i18nt('designer.hint.loadFormTemplate') }}</el-button>
        </div>
      </el-card>
    </template>
  </div>
</template>
<script>
import SvgIcon from '@/components/svg-icon';
import { formTemplates } from '../templatesConfig';
import { useI18n } from '@/utils/i18n';
import { reactive, toRefs, inject, getCurrentInstance } from 'vue';
export default {
  components: {
    SvgIcon,
  },
  icon: 'el-clone',
  label: 'toolbox.templates',
  name: 'templates',
  setup(props) {
    const { i18nt, i18n2t } = useI18n();
    const { proxy } = getCurrentInstance();
    let $current = proxy;

    const designer = inject('designer');
    const getDesignerConfig = inject('getDesignerConfig');

    const data = reactive({
      designerConfig: getDesignerConfig(),
      formTemplates: formTemplates,
    });

    const showFormTemplates = () => {
      if (data.designerConfig['formTemplates'] === undefined) {
        return true;
      }

      return !!data.designerConfig['formTemplates'];
    };
    const loadImageFromTemplate = imgUrl => {
      if (imgUrl.indexOf('http') === 0) {
        return imgUrl;
      } else {
        let imgName = imgUrl.substring(imgUrl.lastIndexOf('/') + 1);
        return require(`@/assets/ft-images/${imgName}`);
      }
    };
    const loadFormTemplate = jsonUrl => {
      $current
        .$confirm(i18nt('designer.hint.loadFormTemplateHint'), i18nt('render.hint.prompt'), {
          cancelButtonText: i18nt('render.hint.cancel'),
          confirmButtonText: i18nt('render.hint.confirm'),
        })
        .then(() => {
          axios
            .get(jsonUrl)
            .then(res => {
              let modifiedFlag = false;
              if (typeof res.data === 'string') {
                modifiedFlag = designer.loadFormJson(JSON.parse(res.data));
              } else if (res.data.constructor === Object) {
                modifiedFlag = designer.loadFormJson(res.data);
              }
              if (modifiedFlag) {
                designer.emitHistoryChange();
              }
              $current.$message.success(i18nt('designer.hint.loadFormTemplateSuccess'));
            })
            .catch(error => {
              $current.$message.error(i18nt('designer.hint.loadFormTemplateFailed') + ':' + error);
            });
        })
        .catch(error => {
          console.error(error);
        });
    };

    return {
      ...toRefs(data),
      i18n2t,
      i18nt,
      loadFormTemplate,
      loadImageFromTemplate,
      showFormTemplates,
    };
  },
  sort: 1,
};
</script>
<style lang="scss" scoped>
.color-svg-icon {
  -webkit-font-smoothing: antialiased;
  color: #8d8d8d;
  font-size: 22px;
}

.el-card.ft-card {
  border: 1px solid #8896b3;
}

.ft-card {
  margin-bottom: 10px;

  .bottom {
    margin-top: 10px;
    line-height: 12px;
  }

  /*
    .image-zoom {
      height: 500px;
      width: 620px
    }
    */

  .ft-title {
    font-size: 13px;
    font-weight: bold;
  }

  .right-button {
    padding: 0;
    float: right;
  }

  .clear-fix:before,
  .clear-fix:after {
    display: table;
    content: '';
  }

  .clear-fix:after {
    clear: both;
  }
}
</style>
